import React, { useContext } from 'react';
// import { Spinner } from '../../../StyledComponent';
import { ButtonPrimary } from '../../../StyledComponent';
import { ContextoFinanceiro } from '../../../../services/financeiro';

import { ReactComponent as PixIcon } from '../../../../assets/novosicones/Financeiro/pix.svg';
import { ContainerButtonPix } from './styledBotaoPix';

export default function BotaoPix({
  processandoPix,
  tema,
  fullWidth,
  parcelas,
  width,
  isCardParcelas,
}) {
  const { setShowModalGerarPix, setParcelasPix } =
    useContext(ContextoFinanceiro);

  function handleClickButtonPix() {
    setShowModalGerarPix(true);
    setParcelasPix(parcelas);
  }

  return (
    <ContainerButtonPix>
      {!processandoPix && !isCardParcelas && (
        <ButtonPrimary
          width={width}
          fullWidth={fullWidth}
          tema={tema}
          light
          onClick={handleClickButtonPix}
          id='pagarComPix'
        >
          <PixIcon />
          PIX
        </ButtonPrimary>
      )}

      {processandoPix && !isCardParcelas && (
        <ButtonPrimary
          fullWidth={fullWidth}
          tema={tema}
          onClick={handleClickButtonPix}
          id='visualizarCodigoPix'
        >
          VISUALIZAR CÓDIGO PIX
        </ButtonPrimary>
      )}

      {processandoPix && isCardParcelas && (
        <span
          className='show-pix'
          id='visualizarCodigoPix'
          onClick={handleClickButtonPix}
        >
          Clique aqui para visualizar
        </span>
      )}
    </ContainerButtonPix>
  );
}
